import { render, staticRenderFns } from "./ProfileIdeas.vue?vue&type=template&id=37965a3e&scoped=true&"
import script from "./ProfileIdeas.vue?vue&type=script&lang=js&"
export * from "./ProfileIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37965a3e",
  null
  
)

export default component.exports